// TODO: to delete the old one later
export var SignalrConnectionHub_Legacy;
(function (SignalrConnectionHub_Legacy) {
    SignalrConnectionHub_Legacy["Stock"] = "stockhub";
    SignalrConnectionHub_Legacy["Receipt"] = "receipthub";
    SignalrConnectionHub_Legacy["Shipment"] = "shipmenthub";
    SignalrConnectionHub_Legacy["Packing"] = "pickinghub";
    SignalrConnectionHub_Legacy["Placement"] = "placementhub";
    SignalrConnectionHub_Legacy["Reclamation"] = "reclamationhub";
})(SignalrConnectionHub_Legacy || (SignalrConnectionHub_Legacy = {}));
